import { render, staticRenderFns } from "./DZBL.vue?vue&type=template&id=73c595a6&scoped=true&"
import script from "./DZBL.vue?vue&type=script&lang=js&"
export * from "./DZBL.vue?vue&type=script&lang=js&"
import style0 from "./DZBL.vue?vue&type=style&index=0&id=73c595a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c595a6",
  null
  
)

export default component.exports